module.exports = __webpack_public_path__ + "img/ratttyDialog.cd749818.png";